// @flow
import styled from 'styled-components';
import colors from '../../../assets/css/colors';

export const TradesMessage = styled.div`
	color: #fff;
	background: ${colors.negative_value};
	display: flex;
	align-items: center;
	height: 60px;
	padding: 0 20px;
	margin-top: 1em;
	> svg {
		margin-right: 1em;
	}
	p {
		font-size: 14px;
		font-weight: bold;
	}
	> div {
		margin-left: auto;
	}
`;

export default TradesMessage;


// WEBPACK FOOTER //
// ./src/pages/league/team/tradesMessage.js